/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody } from '../model/businessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody';
import { BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody1 } from '../model/businessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody1';
import { BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody2 } from '../model/businessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody2';
import { BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody3 } from '../model/businessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody3';
import { BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody } from '../model/businessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody';
import { BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody1 } from '../model/businessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody1';
import { BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody2 } from '../model/businessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody2';
import { BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody3 } from '../model/businessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody3';
import { CommandHandlerResponse } from '../model/commandHandlerResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BusinessMakeSpecificCorrectionsService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:POST/api/BusinessMakeSpecificCorrections/CreateMakeSpecificCorrection AmsResource:{country}/{business}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public createMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public createMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public createMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsCreateMakeSpecificCorrectionBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/BusinessMakeSpecificCorrections/CreateMakeSpecificCorrection`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:PUT/api/BusinessMakeSpecificCorrections/UpdateMakeSpecificCorrection AmsResource:{country}/{business}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateMakeSpecificCorrections(body?: BusinessMakeSpecificCorrectionsUpdateMakeSpecificCorrectionBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/BusinessMakeSpecificCorrections/UpdateMakeSpecificCorrection`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
